import React from 'react';
import { Col, Form, Input, Row, Select, Typography } from 'antd';
import { useTranslation } from 'react-i18next';
import { DatePicker } from 'antd/es';
import Helpers from 'helpers';
import { renderGroupedShopOptions } from 'components/shopOptions';

const datePickerStyles = {
  width: '100%',
};

const { Option } = Select;

const InfoSection = ({
  extrastocks,
  shops,
  inactiveShops,
  contractType,
  isView,
}) => {
  const { t } = useTranslation();
  return (
    <Row gutter={24}>
      <Col span={4}>
        <Typography.Title disabled={isView} level={3}>
          {t('Informazioni Generali')}
        </Typography.Title>
      </Col>
      <Col span={10}>
        <Form.Item label={t('Insegna')} name='company_id'>
          <Select
            disabled={isView}
            {...Helpers.addSearchProps()}
            placeholder={t('Selezioni opzione')}
          >
            <Select.Option value={''}>{t('Selezioni opzione')}</Select.Option>
            {renderGroupedShopOptions({
              shops,
              inactiveShops,
              t,
            })}
          </Select>
        </Form.Item>
      </Col>
      <Col span={10}>
        <Form.Item label={t('Tipologia contratto')} name='contract_type'>
          <Select disabled={isView} placeholder={t('Selezioni opzione')}>
            <Select.Option value={''}>{t('Selezioni opzione')}</Select.Option>
            {Object.keys(contractType).map((i) => (
              <Select.Option key={i} value={i}>
                {contractType[i]}
              </Select.Option>
            ))}
          </Select>
        </Form.Item>
      </Col>
      <Col offset={4} span={10}>
        <Form.Item label={t('Nome richiedente')} name='applicant'>
          <Input.TextArea
            disabled={isView}
            rows={6}
            placeholder={t('Inserisci testo')}
          />
        </Form.Item>
      </Col>
      <Col span={10}>
        <Form.Item label={t('Messaggio')} name='message'>
          <Input.TextArea
            disabled={isView}
            rows={6}
            placeholder={t('Inserisci testo')}
          />
        </Form.Item>
      </Col>
      <Col offset={4} span={10}>
        <Form.Item label={t('Data inizio')} name='date_from'>
          <DatePicker
            disabled={isView}
            format={'DD MMMM YYYY'}
            style={datePickerStyles}
          />
        </Form.Item>
      </Col>
      <Col span={10}>
        <Form.Item label={t('Data fine')} name='date_to'>
          <DatePicker
            disabled={isView}
            format={'DD MMMM YYYY'}
            style={datePickerStyles}
          />
        </Form.Item>
      </Col>
      <Col offset={4} span={9}>
        <Form.Item label={t('Unita’ extrastock')} name='extrastock_id'>
          <Select disabled={isView} placeholder={t('Selezioni opzione')}>
            <Option value={''}>{t('Selezioni opzione')}</Option>
            {extrastocks.map(({ id, title_option }) => (
              <Option key={id} value={id}>
                {title_option}
              </Option>
            ))}
          </Select>
        </Form.Item>
      </Col>
    </Row>
  );
};

export default React.memo(InfoSection);
